// extracted by mini-css-extract-plugin
export default {"body":"house-account-assignment-modal_body__awHjH","searchRow":"house-account-assignment-modal_searchRow__ynNiF","error":"house-account-assignment-modal_error__Zqi+0"};